import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
// import custom hooks

import { saudiFlag, englishFlag, countries } from "../../utils/flags";

//import pngs
import lightCirle from "../../assets/img/light-circle2.png";
import darkCirle from "../../assets/img/dark-circle.png";

import SearchForm from "./SearchForm";

import Container from "react-bootstrap/Container";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

const CurrencyDropdown = ({ changeLang, changeColorMode }) => {
    const [currency, setCurrency] = useState(null);
    const [lang, setLang] = useState(null);
    const [flag, setFlag] = useState(null);
    const [colorMode, setColorMode] = useState(null);
    const [hide, setHide] = useState(true);
    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();

    const changeCurrency = (currency, flag) => {
        setCurrency(currency);
        setFlag(flag);
        Cookies.set("currency", currency);
    };
    const setChangeLang = (langTxt, lang) => {
        setLang(langTxt);
        changeLang(lang);
        Cookies.set("lang", lang);
    };
    const setChangeColorMode = (mode) => {
        Cookies.set("mode", mode);
        setColorMode(mode);
        changeColorMode(mode);
    };

    useEffect(() => {
        // const allcookies = Cookies.get();
        // console.log(allcookies);
        if (!currency) {
            let curr = Cookies.get("currency");
            if (!curr) {
                (curr = "saudi"), Cookies.set("currency", "saudi");
            }
            countries.forEach((i) => {
                if (i.name == curr) {
                    setCurrency(i.name);
                    setFlag(i.flag);
                }
            });
        }
        if (!lang) {
            let tempLang = Cookies.get("lang");
            if (!tempLang) {
                (tempLang = "ar"), Cookies.set("lang", "ar");
            }
            setLang(tempLang == "ar" ? "ع" : "en");
        }
        if (!colorMode) {
            let tempColorMode = Cookies.get("mode");
            if (!tempColorMode) {
                tempColorMode = "light";
                Cookies.set("mode", "light");
            }
            setColorMode(tempColorMode);
        }
    }, [currency, lang, colorMode]);

    return (
        <>
            <div className={`dropdown`} onMouseLeave={() => setHide(true)}>
                <Container className="dropdown-row">
                    <button
                        className="dropbtn"
                        onMouseOver={() => setHide(false)}
                        onClick={() => setHide(!hide)}
                    >
                        <img src={flag} alt="flag" />
                        <p>
                            {lang} | {t(`currencies.${currency}.txt`)}
                        </p>
                    </button>
                    {windowWidth < 992 && <SearchForm />}
                </Container>
                <div className={`dropdown-content ${hide && "hide"}`}>
                    <div className="dropdown-title">
                        <p>{t(`nav.currency`)}</p>
                        <div
                            className="closeSvg"
                            onClick={() => setHide(true)}
                        ></div>
                    </div>
                    <ul>
                        {countries.map((i) => (
                            <li
                                key={i.name}
                                className={i.name == currency && "active"}
                                onClick={() => changeCurrency(i.name, i.flag)}
                            >
                                <img
                                    className="country-flag"
                                    src={i.flag}
                                    alt={t(`currencies.${i.name}.txt`)}
                                />
                                <p>{t(`currencies.${i.name}.txt`)}</p>
                            </li>
                        ))}
                    </ul>
                    {/* langauge part */}
                    <div className="dropdown-title">
                        <p>{t(`nav.lang`)}</p>
                    </div>
                    <ul>
                        <li
                            className={lang == "ع" && `active`}
                            onClick={() => setChangeLang("ع", "ar")}
                        >
                            <img
                                className="country-flag"
                                src={saudiFlag}
                                alt="saudi flag"
                            />
                            <p>{t(`nav.ar`)}</p>
                        </li>
                        <li
                            className={lang == "en" && `active`}
                            onClick={() => setChangeLang("en", "en")}
                        >
                            <img
                                className="country-flag"
                                src={englishFlag}
                                alt="english flag"
                            />
                            <p>{t(`nav.en`)}</p>
                        </li>
                    </ul>
                    {/* color mode part */}
                    <div className="dropdown-title">
                        <p>{t(`nav.colorMode`)}</p>
                    </div>
                    <ul className="color-mode-list">
                        <li
                            className={colorMode == "light" && `active`}
                            onClick={() => setChangeColorMode("light")}
                        >
                            <img
                                className="country-flag"
                                src={lightCirle}
                                alt="light circle"
                            />
                            <p>{t(`nav.light`)}</p>
                        </li>
                        <li
                            className={colorMode == "dark" && `active`}
                            onClick={() => setChangeColorMode("dark")}
                        >
                            <img
                                className="country-flag"
                                src={darkCirle}
                                alt="dark circle"
                            />
                            <p>{t(`nav.dark`)}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default CurrencyDropdown;
